import "./FAQ.scss";

import { useTranslation } from "react-i18next";

const FAQ = (props) => {
    const { t } = useTranslation(["common","faq"]);

    let faqs = t('faq:faqs', { returnObjects: true });
    if(typeof faqs === "string"){
        faqs = [];
    }

    const handleDetails = (event) => {
        const detailsList = document.querySelectorAll("details");
        if (!event.target.open) return;
        for (let details of detailsList) {
            details.open = details === event.target;
        }
    }
    return (
        <div className={`faq ${props.className}`}>
            {faqs.map((f, idx) => (
                <details key={idx} onToggle={handleDetails}>
                    <summary >
                        <span className="faq-marker">+</span>
                        <h3>{f.q}</h3>
                    </summary>
                    <p>{f.a}</p>
                </details>
            ))}
        </div>
    )
}
export default FAQ;